import dayjs from "dayjs";
import { Tooltip, Rate } from "antd";
import { EyeOutlined } from "@ant-design/icons";

export const tabData = [
	{ label: "Advocates", content: "LAWYERS", key: "1" },
	{ label: "Customers", content: "CUSTOMERS", key: "2" },
	{ label: "Feedback", content: "FEEDBACK", key: "3" }
];

export const supportStatusOptions = [
    { key: "PENDING", label: "PENDING", value: "PENDING" },
    { key: "COMPLETED", label: "COMPLETED", value: "COMPLETED" }
];

export const feedbackByOptions = [
    { key: "LAWYER", label: "Advocate", value: "LAWYER" },
    { key: "CUSTOMER", label: "Customer", value: "CUSTOMER" }
];

export const actionDropdownMenu = [
    { key: "view", label: "View" },
    { key: "complete", label: "Complete Support" }
];

export const LAWYER_SUPPORT_COLUMNS = ({ actionRender, supportStatusOptions, onViewProofImage }) => [
	{
		title: "SNo",
		width: 40,
		align: "center",
        render: (_, detail, index) => <>{index + 1}</>
	},
	{
		title: "Support ID",
		width: 80,
		render: (detail) => detail?.supportNo || "Nil",
	},
	{
		title: "Date",
		width: 80,
		align: "center",
		render: (detail) => detail?.supportDate ? dayjs(detail?.supportDate).format("DD-MM-YYYY") : "Nil"
	},
	{
		title: "Advocate Name/ Id",
		width: 100,
		render: (detail) => (
			<div>
				<span style={{ fontWeight: '600'}}>{detail?.raisedByName || "Nil"}</span>
				<br />
				<small style={{ color: "grey" }}>{detail?.raisedByNo || "Nil"}</small>
			</div>
		)
	},
	{
		title: "Support Description",
		width: 250,
		dataIndex: "description",
        render: (text) => text?.length > 50 ? (
            <Tooltip title={text}>
                <span>{text?.slice(0, 50)}...</span>
            </Tooltip>
        ) : (
            <span>{text || "Nil"}</span>
        )
	},
    ...(supportStatusOptions === "COMPLETED" ? [
        {
            title: "Action Taken",
			width: 200,
            dataIndex: "actionItem",
            render: (text) => text?.length > 50 ? (
            <Tooltip title={text}>
                <span>{text?.slice(0, 50)}...</span>
            </Tooltip>
        ) : (
            <span>{text || "Nil"}</span>
        )
        }
    ] : []),
    {
        title: "Proof Image",
        width: 80,
        align: "center",
        render: (detail) => {
            const proofAttachments = Array.isArray(detail?.attachmentUrl)
                ? detail?.attachmentUrl?.filter((attachment) => Boolean(attachment))
                : detail?.attachmentUrl
                    ? [detail?.attachmentUrl]
                    : [];
            if (!proofAttachments?.length) return "Nil";
            return (
                <EyeOutlined 
                    style={{ fontSize: '18px', cursor: 'pointer', color: '#005D60' }}
                    onClick={(event) => {
                        event?.stopPropagation();
                        onViewProofImage(proofAttachments);
                    }}
                />
            );
        }
    },
    {
		title: "Complaint Status",
        width: 90,
		render: (detail) => {
			return <>
				{
					detail?.complaintStatus === "COMPLETED" ? <div className="success-status">
						<p className="custom-header">Completed</p>
					</div> : detail?.complaintStatus === "PENDING" ? <div className="pending-status">
						<p className="custom-header">Pending</p>
					</div> : <div style={{textAlign:"center"}}>Nil</div>
				}
			</>
		}
	},
    {
        title: <div style={{ display: "flex", justifyContent: "center" }}>Action</div>,
        width: 80,
        align: "center",
        fixed: "right",
        render: (detail) => actionRender(detail)
    }
];

export const CUSTOMER_SUPPORT_COLUMNS = ({ actionRender, supportStatusOptions, onViewProofImage }) => [
	{
		title: "SNo",
		width: 40,
		align: "center",
        render: (_, detail, index) => <>{index + 1}</>
	},
	{
		title: "Support ID",
		width: 80,
		render: (detail) => detail?.supportNo || "Nil",
	},
	{
		title: "Date",
		width: 80,
		render: (detail) => detail?.supportDate ? dayjs(detail?.supportDate).format("DD-MM-YYYY") : "Nil"
	},
	{
		title: "Customer Name/ Id",
		width: 100,
		render: (detail) => (
			<div>
				<span style={{ fontWeight: '600'}}>{detail?.raisedByName || "Nil"}</span>
				<br />
				<small style={{ color: "grey" }}>{detail?.raisedByNo || "Nil"}</small>
			</div>
		)
	},
	{
		title: "Support Description",
		width: 200,
		dataIndex: "description",
        render: (text) => text?.length > 50 ? (
            <Tooltip title={text}>
                <span>{text?.slice(0, 50)}...</span>
            </Tooltip>
        ) : (
            <span>{text || "Nil"}</span>
        )
	},
    ...(supportStatusOptions === "COMPLETED" ? [
        {
            title: "Action Item",
			width: 250,
            dataIndex: "actionItem",
            render: (text) => text?.length > 50 ? (
            <Tooltip title={text}>
                <span>{text?.slice(0, 50)}...</span>
            </Tooltip>
        ) : (
            <span>{text || "Nil"}</span>
        )
        }
    ] : []),
    {
        title: "Proof Image",
        width: 80,
        align: "center",
        render: (detail) => {
            const proofAttachments = Array.isArray(detail?.attachmentUrl)
                ? detail?.attachmentUrl?.filter((attachment) => Boolean(attachment))
                : detail?.attachmentUrl
                    ? [detail?.attachmentUrl]
                    : [];
            if (!proofAttachments?.length) return "Nil";
            return (
                <EyeOutlined 
                    style={{ fontSize: '18px', cursor: 'pointer', color: '#005D60' }}
                    onClick={(event) => {
                        event?.stopPropagation();
                        onViewProofImage(proofAttachments);
                    }}
                />
            );
        }
    },
    {
		title: "Complaint Status",
        width: 90,
		render: (detail) => {
			return <>
				{
					detail?.complaintStatus === "COMPLETED" ? <div className="success-status">
						<p className="custom-header">Completed</p>
					</div> : detail?.complaintStatus === "PENDING" ? <div className="pending-status">
						<p className="custom-header">Pending</p>
					</div> : <div style={{textAlign:"center"}}>Nil</div>
				}
			</>
		}
	},
    {
        title: <div style={{ display: "flex", justifyContent: "center" }}>Action</div>,
        fixed: "right",
        align: "center",
        width: 80,
        render: (detail) => actionRender(detail)
    }
];

export const FEEDBACK_COLUMNS = [
    {
        title: "SNo",
        width: 40,
        align: "center",
        render: (_, __, index) => <>{index + 1}</>
    },
    {
        title: "Date",
        dataIndex: "feedbackDate",
        width: 80,
        align: "center",
        render: (text) => text ? dayjs(text).format("DD-MM-YYYY") : "Nil"
    },
    {
        title: "User Name/ Id",
        width: 100,
        render: (_, record) => (
            <div>
                <span style={{ fontWeight: '600'}}>{record?.userName || "Nil"}</span>
				<br />
				<small style={{ color: "grey" }}>{record?.userNo || "Nil"}</small>
            </div>
        )
    },
    {
        title: "Ratings",
        dataIndex: "rating",
        width: 100,
        render: (rating) => rating ? <Rate disabled value={rating} /> : "Nil"
    },
    {
        title: "Feedback Description",
        dataIndex: "feedbackDescription",
        width: 250,
        render: (text) => text?.length > 50 ? (
            <Tooltip title={text}>
                <span>{text?.slice(0, 50)}...</span>
            </Tooltip>
        ) : (
            <span>{text || "Nil"}</span>
        )
    }
];
